import Entity from 'lib/Entity';
import { cloneDeep } from 'lodash';

export default class BlockedUser extends Entity {
  parse(response: any) {
    const blockedUser = cloneDeep(response);
    blockedUser['blocked_at'] = new Date(blockedUser['blocked_at']);
    return blockedUser;
  }

  getBlockedAt(): Date {
    return this.get('blocked_at');
  }

  getColor(): string {
    return this.get('color');
  }

  getInitials(): string {
    return this.get('initials');
  }

  getName(): string {
    return this.get('name');
  }
}
